import React, {memo, useState} from 'react'
import {Container, Message} from 'semantic-ui-react'
import {userAccount} from '../../util'
import {withErrorHandling, withPropsPresent} from '../../hoc'

const _AccountWarning = (
  {
    me
  }
) => {
  const account = userAccount(me) || {
    status: 'active',
    stats: {userCount: 0, serviceCount: 0},
    limits: {maxServiceCount: 1, maxUserCount: 5}
  }
  const messages = []
  let error = false
  let warning = false
  let headerMessage = ''
  if (account.status !== 'active') {
    error = true
    headerMessage = 'There Are Issues With Your Account'
    messages.push(`Your billing manager needs to update your card info or downgrade to the free plan.`)
    messages.push('You will only be able to view your existing items in the console until this is resolved.')
  } else {
    warning = true
    headerMessage = `Your Current Plan Is At It's Limits`
    const serviceCountLimitReached = account.stats.serviceCount >= account.limits.maxServiceCount
    const userCountLimitReached = account.stats.userCount >= account.limits.maxUserCount
    if (serviceCountLimitReached) {
      messages.push(`You've reached your service limit of: ${account.limits.maxServiceCount}. Adding, uploading, and cloning services is currently disabled`)
    }
    if (userCountLimitReached) {
      messages.push(`You've reached your user limit of: ${account.limits.maxUserCount}. Inviting users is currently disabled`)
    }
    if (serviceCountLimitReached || userCountLimitReached) {
      messages.push(`You can ask your billing manager to upgrade your plan${account.limits.customized ? ',' : ' or'} continue with the current plan as is${account.limits.customized ? ', or contact support to increase limits.' : ''}`)
    }
  }

  const [visible, setVisible] = useState(true)

  const onDismiss = () => {
    setVisible(false)
  }

  return (
    <Container style={{marginTop: '7em', marginBottom: '2em'}} data-testid='account-warning-container'>
      {
        messages.length > 0 && error && (
          <Message
            error
            header={headerMessage}
            list={messages}
          />
        )
      }
      {
        visible && messages.length > 0 && warning && (
          <Message
            onDismiss={onDismiss}
            header={headerMessage}
            list={messages}
          />
        )
      }
    </Container>
  )
}

let AccountWarning = (props) => {
  return (<_AccountWarning {...props}/>)
}

AccountWarning = withPropsPresent(AccountWarning, ['me'])
AccountWarning = withErrorHandling(AccountWarning)
AccountWarning = memo(AccountWarning)

export {AccountWarning, _AccountWarning}

export default AccountWarning